<template>
  <div class="main">
    <div>
      <div class="titlefont">
        <div class="titleAnimation">
          <div class="title">{{ production.title }}</div>
          <div class="desc">
            {{ production.desc }}
          </div>
        </div>
      </div>
      <div class="conMain">
        <div class="con">
          <div class="conLeft leftBox">
            <div
              class="bigImg"
              @click="lookBigImage(studentsInfo.bgImg[0].url)"
              v-if="studentsInfo.file"
              style="cursor: pointer"
            >
              <img :src="studentsInfo.file[0].url" width="100%" alt="" />
            </div>
          </div>
          <div class="conR rightShow">
            <div class="tit"> <img src="./../img/font.png" width="221" alt=""><!-- {{ studentsInfo.title }} --> <span>「 {{ studentsInfo.subTitle }} 」</span></div>
            <div class="subTit">{{ studentsInfo.url }}</div>
            <!-- <div class="des">{{ studentsInfo.url }}</div> -->
            <div class="botton">
              <el-button @click="lookBigImage(studentsInfo.bgImg[0].url)"
                >查看学员作品<em></em
              ></el-button>
            </div>
            <div class="swiper">
              <div class="label"></div>
              <div class="swiperItems">
                <div
                  class="rowBut"
                  v-if="production.titleAndUrlImage.length > 4"
                >
                  <div class="icon iconfont swiper-button-prev">
                    <div class="swLeftBut"></div>
                  </div>
                  <div class="icon iconfont swiper-button-next">
                    <div class="swRightBut"></div>
                  </div>
                </div>
                <swiper :options="swiperOption">
                  <swiper-slide
                    id="num"
                    class="items"
                    v-for="(item, index) in production.titleAndUrlImage"
                    :key="index"
                  >
                    <div
                      @click="statentsShowHandle(index)"
                      :class="{
                        imgitem: true,
                        act: studentsShowIndex == index,
                      }"
                    >
                      <div class="active"></div>
                      <img :src="item.file[0].url" width="131" alt="" />
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="biggerImgPreview"
      class="bigImgDialog"
      style="margin-top: 3vh"
    >
      <div class="close" @click="closeImg">
        <img src="./../img/close.png" width="28px" alt="" />
      </div>
      <div style="overflow: hidden">
        <div style="overflow-y: scroll; height: 93vh">
          <img :src="showBigImageUrl" width="100%" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    studentsWorksList: {
      type: Array,
      default: () => [],
    },
    production: {
      type: Object,
      default: () => {},
    },
    studentsInfo: {
      type: Object,
      default: () => {},
    },
    showBigImageUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      biggerImgPreview: false,
      // showBigImageUrl: "",
      studentsShowIndex: 0,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 25,
        slidesPerGroup: 2,
        allowTouchMove: false,
        loop: false,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "swiper-button-disabled-class",
        },
      },
    };
  },
  methods: {
    closeImg() {
      this.biggerImgPreview = false;
      this.showBigImageUrl = "";
    },
    lookBigImage(url) {
      this.$emit("showBigImghandle", url);
      // this.biggerImgPreview = true;
      // this.showBigImageUrl = url;
    },
    // 学员作品信息展示切换
    statentsShowHandle(index) {
      this.studentsShowIndex = index;
      this.$emit("statentsShowHandle", index);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
